import React,{useRef} from 'react';
import {trans} from '../utils';
import logo from "../../assets/img/logo-login.png";
import ReactToPrint from "react-to-print";


const Abstracts = () => {

    const componentpmRef = useRef();
    const componentpyRef = useRef();
    const componentpnRef = useRef();
    const componentpxRef = useRef();
    const componentplRef = useRef();

    return (
      <div>
       <div className="">
            <div className='card card-custom card-stretch gutter-b'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="card-header">
                            <div className="card-title m-0">
                                <h3 className="fw-bolder m-0">{trans('Abstract types')}</h3>
                            </div>
                        </div>
                        <div className='card-body row'>
                            <div className="col-lg-6 col-xxl-6 text-right">
                                <button type="button" className="btn btn btn-light-primary mr-4" data-toggle="modal" data-target="#CertificateCompletionModal">
                                       <span> {trans('View Report')}
                                       </span>
                                </button>
                                <ReactToPrint
                                    trigger={() => <button className="btn btn-light-success print-btn mr-4"  type={"button"}>  {trans("Print Report")}</button>}
                                    content={() => componentpmRef.current}
                                    fileName="شهـادة_إنجاز.pdf"
                                />
                            </div>
                            <div className="col-lg-6 col-xxl-6 text-right">
                                <div className="d-flex flex-column justify-content-center flex-row-fluid pe-11 mb-5">
                                    <div className="fw-bolder mt-3">
                                    شهـادة إنجاز
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-xxl-6 text-right mt-5">
                                <button type="button" className="btn btn btn-light-primary mr-4" data-toggle="modal" data-target="#EntitlementScheduleModal">
                                       <span> {trans('View Report')}
                                       </span>
                                </button>
                                <ReactToPrint
                                    trigger={() => <button className="btn btn-light-success print-btn mr-4"  type={"button"}>  {trans("Print Report")}</button>}
                                    content={() => componentpnRef.current}
                                    fileName="جـدول_الاستحقاق.pdf"
                                />
                            </div>
                            <div className="col-lg-6 col-xxl-6 text-right mt-5">
                                <div className="d-flex flex-column justify-content-center flex-row-fluid pe-11 mb-5">
                                    <div className="fw-bolder mt-3">
                                    جـدول الاستحقاق
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-xxl-6 text-right mt-5">
                                <button type="button" className="btn btn btn-light-primary mr-4" data-toggle="modal" data-target="#BrokenDevicesModal">
                                       <span> {trans('View Report')}
                                       </span>
                                </button>
                                <ReactToPrint
                                    trigger={() => <button className="btn btn-light-success print-btn mr-4"  type={"button"}>  {trans("Print Report")}</button>}
                                    content={() => componentpyRef.current}
                                    fileName="جدول الحسميات_على_الأجهزة_المتعطلة.pdf"
                                />
                            </div>
                            <div className="col-lg-6 col-xxl-6 text-right mt-5">
                                <div className="d-flex flex-column justify-content-center flex-row-fluid pe-11 mb-5">
                                    <div className="fw-bolder mt-3">
                                    جدول الحسميات على الأجهزة المتعطلة
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-xxl-6 text-right mt-5">
                                <button type="button" className="btn btn btn-light-primary mr-4" data-toggle="modal" data-target="#PreventiveMaintenanceModal">
                                       <span> {trans('View Report')}
                                       </span>
                                </button>
                                <ReactToPrint
                                    trigger={() => <button className="btn btn-light-success print-btn mr-4"  type={"button"}>  {trans("Print Report")}</button>}
                                    content={() => componentpxRef.current}
                                    fileName="جدول الصيانة_الوقائية.pdf"
                                />
                            </div>
                            <div className="col-lg-6 col-xxl-6 text-right mt-5">
                                <div className="d-flex flex-column justify-content-center flex-row-fluid pe-11 mb-5">
                                    <div className="fw-bolder mt-3">
                                    تفاصيل تطبيق جدول حسميات التقصير في أعمال الصيانة الوقائية للأجهزة الطبية
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-xxl-6 text-right mt-5">
                                <button type="button" className="btn btn btn-light-primary mr-4" data-toggle="modal" data-target="#SubContractorModal">
                                       <span> {trans('View Report')}
                                       </span>
                                </button>
                                <ReactToPrint
                                    trigger={() => <button className="btn btn-light-success print-btn mr-4"  type={"button"}>  {trans("Print Report")}</button>}
                                    content={() => componentplRef.current}
                                    fileName="جدول تكاليف_مقاولي_الباطن.pdf"
                                />
                            </div>
                            <div className="col-lg-6 col-xxl-6 text-right mt-5">
                                <div className="d-flex flex-column justify-content-center flex-row-fluid pe-11 mb-5">
                                    <div className="fw-bolder mt-3">
                                    جدول تكاليف مقاولي الباطن للأجهزة الطبية التخصصية الموجودة بالموقع 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="CertificateCompletionModal" tabIndex="-1" role="dialog" aria-labelledby="CertificateCompletionModalLabel" aria-hidden="true" >
               <div className="modal-dialog modal-xl" role="document">
                   <div className="modal-content container" ref={componentpmRef}>
                       <div className="modal-header no-border">
                           <h5 className="modal-title container" id="exampleModalLabel">
                               <div className="row">
                                   <div className="col-md-4">
                                       <h5>Kingdom of Saudi Arabia</h5>
                                       <h5>Ministry of Health</h5>
                                       <h5>General Administration of Medical Maintenance</h5>
                                   </div>
                                   <div className="col-md-4 text-center">
                                       <img alt="Logo" src={logo} className="h-100px m-2"/>
                                       <h4>
                                       شهـادة إنجاز
                                       </h4>
                                   </div>
                                   <div className="col-md-4">
                                       <h5 className="text-right">المملكة العربية السعودية</h5>
                                       <h5 className="text-right">وزارة الصحة</h5>
                                       <h5 className="text-right">الإدارة العامة للصيانة الطبية</h5>
                                   </div>
                                    <div className='col-md-12'>
                                        <h5 className='text-center'>كراسة الشروط والمواصفات لصيانة وإصلاح الأجهزة والمعدات الطبية لمستشفيات منطقة تبوك </h5>
                                    </div>
                               </div>
                           </h5>
                       </div>
                       <div className="modal-header no-border">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                            <div className="col-md-4 text-left mt-3">
                                            <h4 className="n-border text-center">
                                            تبوك
                                            </h4>
                                        </div>
                                        <div className="col-md-8 text-right mt-3">
                                            <h5> :أعمال إصلاح وصيانة الأجهزة والمعدات الطبية الموجودة فى المواقع التابعة لصحة منطقة</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                        <div className="row">
                                                <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                            </div>
                                            <div className="col-md-6">
                                                <h5>
                                                :إسم المنطقة
                                                </h5>
                                            </div>
                                        </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="row">
                                        <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <h5>
                                            :بمقتضى العقد رقم
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                        <div className="row">
                                            <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                            </div>
                                            <div className="col-md-6">
                                                <h5>
                                                :إسم الموقع
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                <div className="col-md-6 mt-3">
                                    <div className="row">
                                        <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <h5>
                                            :تاريخ
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                       </div>
                       <div className='moda-body mt-3'>
                            <div className='modal-title'>
                                <div className='col-md-12'>
                                    <h5 className='text-center'>نموذج  رقم (  1  )</h5>
                                    <h5 className='text-center'>للدفعة الشهرية رقم (       )</h5>
                                    <h5 className='text-center'>قام المتعهد : المملكة العربية السعودية</h5>
                                    <h5 className='text-center'>في المـدة من: 30/1/2024 الي 30/1/2024</h5>
                                    <h5 className='text-center'>ومدتها شهر ميلادي بالكامل وذلك بأعمال الإصلاحات والصيانة للأجهزة والمعدات الطبية الموجودة في: <span>تبوك</span></h5>
                                    <h5 className='text-center'>موقــــع مستشفى: <span>المملكة العربية السعودية</span></h5>
                                </div>
                                <div className='col-md-12 mt-10'>
                                    <h6 className='text-right'>
                                    بموجب ما هو موضح بالأوراق الإثباتية المشفوعة بهذه الشهادة والتي تم إعدادها لتقديمها مع المستندات الأخرى اللازمة لصرف مستحقات المتعهد عن المدة المذكورة بمقتضى العقد المبرم معه وحسب النظام.
والله الموفق ،،
                                    </h6>
                                </div>
                            </div>
                       </div>
                       <div className='modal-body mt-5'>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="table-responsive" dir='rtl'>
                                        <table className="table table-bordered">
                                            <thead>
                                            <tr className="text-center">
                                                <th scope="col" className="pl-4 text-center fw-bolder">
                                                    <h5>
                                                        #
                                                    </h5>
                                                </th>
                                                <th scope="col">
                                                    <h5 className='text-center'>
                                                    مدير الصيانة بالموقع
                                                    </h5>
                                                </th>
                                                <th scope="col">
                                                    <h5 className='text-center'>
                                                    المشرف على أعمال المقاول(مهندس الوزارة) بالموقع 
                                                    </h5>
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="text-center">
                                                    <th scope="row" className="pl-4 text-center fw-bolder">الاسم:</th>
                                                    <td className='text-center'>test</td>
                                                    <td className='text-center'>test</td>
                                                </tr>
                                                <tr className="text-center">
                                                    <th scope="row" className="pl-4 text-center fw-bolder">التوقيع:</th>
                                                    <td className='text-center'>test</td>
                                                    <td className='text-center'>test</td>
                                                </tr>
                                                <tr className="text-center">
                                                    <th scope="row" className="pl-4 text-center fw-bolder">التاريخ:</th>
                                                    <td className='text-center'>test</td>
                                                    <td className='text-center'>test</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='modal-footer mt-5'>
                            <div className='container'>
                                <div className='row'>
                                <div className='col-md-6 h-225px'>
                                <h5 className='text-center'>ختم الموقع</h5>
                            </div>
                            <div className='col-md-6 h-225px'>
                                <h5 className='text-center'>(ادارة الموقع / المواقع) ختم</h5>
                            </div>
                                </div>
                            </div>
                        </div>
                    </div>
               </div>
           </div>
           <div className="modal fade" id="EntitlementScheduleModal" tabIndex="-1" role="dialog" aria-labelledby="EntitlementScheduleModalLabel" aria-hidden="true" >
               <div className="modal-dialog modal-xl" role="document">
                   <div className="modal-content container" ref={componentpnRef}>
                       <div className="modal-header no-border">
                           <h5 className="modal-title container" id="exampleModalLabel">
                               <div className="row">
                                   <div className="col-md-4">
                                       <h5>Kingdom of Saudi Arabia</h5>
                                       <h5>Ministry of Health</h5>
                                       <h5>General Administration of Medical Maintenance</h5>
                                   </div>
                                   <div className="col-md-4 text-center">
                                       <img alt="Logo" src={logo} className="h-100px m-2"/>
                                       <h4>
                                       جـدول الاستحقاق
                                       </h4>
                                   </div>
                                   <div className="col-md-4">
                                       <h5 className="text-right">المملكة العربية السعودية</h5>
                                       <h5 className="text-right">وزارة الصحة</h5>
                                       <h5 className="text-right">الإدارة العامة للصيانة الطبية</h5>
                                   </div>
                                    <div className='col-md-12'>
                                        <h5 className='text-center'>كراسة الشروط والمواصفات لصيانة وإصلاح الأجهزة والمعدات الطبية لمستشفيات منطقة تبوك </h5>
                                    </div>
                               </div>
                           </h5>
                       </div>
                       <div className="modal-header no-border">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                            <div className="col-md-4 text-left mt-3">
                                            <h4 className="n-border text-center">
                                            تبوك
                                            </h4>
                                        </div>
                                        <div className="col-md-8 text-right mt-3">
                                            <h5> :أعمال إصلاح وصيانة الأجهزة والمعدات الطبية الموجودة فى المواقع التابعة لصحة منطقة</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                        <div className="row">
                                                <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                            </div>
                                            <div className="col-md-6">
                                                <h5>
                                                :إسم المنطقة
                                                </h5>
                                            </div>
                                        </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="row">
                                        <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <h5>
                                            :بمقتضى العقد رقم
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                        <div className="row">
                                            <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                            </div>
                                            <div className="col-md-6">
                                                <h5>
                                                :إسم الموقع
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                <div className="col-md-6 mt-3">
                                    <div className="row">
                                        <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <h5>
                                            :تاريخ
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                       </div>
                       <div className='moda-body mt-3'>
                            <div className='modal-title'>
                                <div className='col-md-12'>
                                    <h5 className='text-center'>نموذج  رقم (  2  )</h5>
                                    <h5 className='text-center'>للدفعة الشهرية رقم (       )</h5>
                                    <h5 className='text-center'>قام المتعهد : المملكة العربية السعودية</h5>
                                    <h5 className='text-center'>في المـدة من: 30/1/2024 الي 30/1/2024</h5>
                                    <h5 className='text-center'> ومدتها شهر ميلادي واحد بالكامل</h5>
                                </div>
                            </div>
                       </div>
                       <div className='modal-body mt-5'>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="table-responsive">
                                        <table  className="table table-bordered">
                                            <thead>
                                                <tr className="text-center">
                                                    <th rowspan="2" className='text-center'>ملاحظات</th>
                                                    <th rowspan="2" className='text-center'>المبلغ المستحق بعد الحسميات</th>
                                                    <th colspan="2" className='text-center'>الحسميات إن وجـدت</th>
                                                    <th rowspan="2" className='text-center'>القيمة الشهرية حسب العقد</th>
                                                    <th rowspan="2" className='text-center'>البيـــــــــان</th>
                                                    <th rowspan="2" className='text-center'>رقم البند</th>
                                                </tr>
                                                <tr className="text-center">
                                                <th className='text-center'>كغرامة</th>
                                                <th className='text-center'>كمقابل</th>
                                            </tr>
                                        </thead>
                                            <tbody>
                                                <tr className='text-center'>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>المــوظفون</td>
                                                    <td>1</td>
                                                </tr>
                                                <tr className='text-center'>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>مقاولو الباطن حسب الزيارات المنفذة</td>
                                                    <td>1</td>
                                                </tr>
                                                <tr className='text-center'>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>التأخير في إصلاح الأجهزة</td>
                                                    <td>1</td>
                                                </tr>
                                                <tr className='text-center'>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>التقصير في الصيانة الوقائية</td>
                                                    <td>1</td>
                                                </tr>
                                                <tr className='text-center'>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>مجموع المبالغ في كل عمود</td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <h5 className='text-right mt-5'>إجمالي الاستحقاق الشهري بعد الحسميات إن وجـــدت هي مبلغ (                                        )ريـــال</h5>
                                    <h5 className='text-right mt-5'>فقط وقـدره (            ) لا غير</h5>
                                </div>
                            </div>
                        </div>
                        <div className='modal-body mt-5'>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="table-responsive" dir='rtl'>
                                        <table className="table table-bordered">
                                            <thead>
                                            <tr className="text-center">
                                                <th scope="col" className="pl-4 text-center fw-bolder">
                                                    <h5>
                                                        #
                                                    </h5>
                                                </th>
                                                <th scope="col">
                                                    <h5 className='text-center'>
                                                    مدير الصيانة بالموقع
                                                    </h5>
                                                </th>
                                                <th scope="col">
                                                    <h5 className='text-center'>
                                                    المشرف على أعمال المقاول(مهندس الوزارة) بالموقع 
                                                    </h5>
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="text-center">
                                                    <th scope="row" className="pl-4 text-center fw-bolder">الاسم:</th>
                                                    <td className='text-center'>test</td>
                                                    <td className='text-center'>test</td>
                                                </tr>
                                                <tr className="text-center">
                                                    <th scope="row" className="pl-4 text-center fw-bolder">التوقيع:</th>
                                                    <td className='text-center'>test</td>
                                                    <td className='text-center'>test</td>
                                                </tr>
                                                <tr className="text-center">
                                                    <th scope="row" className="pl-4 text-center fw-bolder">التاريخ:</th>
                                                    <td className='text-center'>test</td>
                                                    <td className='text-center'>test</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='modal-footer mt-5'>
                            <div className='container'>
                                <div className='row'>
                                    <div className='col-md-6 h-225px'>
                                        <h5 className='text-center'>ختم الموقع</h5>
                                    </div>
                                    <div className='col-md-6 h-225px'>
                                        <h5 className='text-center'>(ادارة الموقع / المواقع) ختم</h5>
                                    </div>
                                    <div className='col-md-12 text-right'>
                                        <h5>ملحوظـــة</h5>
                                        <p>أ - يتم تعبئة هذا الجدول شهريا بموجب جداول الأسعار بالعقد ومن واقع النماذج الأخرى المرفقة بعد استيفائها وهي أرقام:</p>
                                        <ul dir='rtl'>
                                        <li>ـ / 2- ب ، تكاليف مقاولي الباطن.</li>
                                        <li>ـ / 2- جـ ، تفاصيل الحسميات تعطل الأجهزة.</li>
                                        <li>ـ / 2- د تفاصيل حسميات التقصير في الصيانة الدورية الوقائية.</li>
                                        </ul>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
               </div>
           </div>
           <div className="modal fade" id="BrokenDevicesModal" tabIndex="-1" role="dialog" aria-labelledby="BrokenDevicesModalLabel" aria-hidden="true" >
               <div className="modal-dialog modal-xl" role="document">
                   <div className="modal-content container" ref={componentpnRef}>
                       <div className="modal-header no-border">
                           <h5 className="modal-title container" id="exampleModalLabel">
                               <div className="row">
                                   <div className="col-md-4">
                                       <h5>Kingdom of Saudi Arabia</h5>
                                       <h5>Ministry of Health</h5>
                                       <h5>General Administration of Medical Maintenance</h5>
                                   </div>
                                   <div className="col-md-4 text-center">
                                       <img alt="Logo" src={logo} className="h-100px m-2"/>
                                       <h4>
                                       جدول الحسميات على الأجهزة المتعطلة
                                       </h4>
                                   </div>
                                   <div className="col-md-4">
                                       <h5 className="text-right">المملكة العربية السعودية</h5>
                                       <h5 className="text-right">وزارة الصحة</h5>
                                       <h5 className="text-right">الإدارة العامة للصيانة الطبية</h5>
                                   </div>
                                    <div className='col-md-12'>
                                        <h5 className='text-center'>كراسة الشروط والمواصفات لصيانة وإصلاح الأجهزة والمعدات الطبية لمستشفيات منطقة تبوك </h5>
                                    </div>
                               </div>
                           </h5>
                       </div>
                       <div className="modal-header no-border">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                            <div className="col-md-4 text-left mt-3">
                                            <h4 className="n-border text-center">
                                            تبوك
                                            </h4>
                                        </div>
                                        <div className="col-md-8 text-right mt-3">
                                            <h5> :أعمال إصلاح وصيانة الأجهزة والمعدات الطبية الموجودة فى المواقع التابعة لصحة منطقة</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                        <div className="row">
                                                <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                            </div>
                                            <div className="col-md-6">
                                                <h5>
                                                :إسم المنطقة
                                                </h5>
                                            </div>
                                        </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="row">
                                        <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <h5>
                                            :بمقتضى العقد رقم
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                        <div className="row">
                                            <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                            </div>
                                            <div className="col-md-6">
                                                <h5>
                                                :إسم الموقع
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                <div className="col-md-6 mt-3">
                                    <div className="row">
                                        <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <h5>
                                            :تاريخ
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                       </div>
                       <div className='moda-body mt-3'>
                            <div className='modal-title'>
                                <div className='col-md-12'>
                                    <h5 className='text-center'>نموذج  رقم (  3  )</h5>
                                    <h5 className='text-center'>للدفعة الشهرية رقم (       )</h5>
                                    <h5 className='text-center'>المبرم مع : المملكة العربية السعودية</h5>
                                    <h5 className='text-center'>في المـدة من: 30/1/2024 الي 30/1/2024</h5>
                                    <h5 className='text-center'> والفترات السابقة</h5>
                                </div>
                            </div>
                       </div>
                       <div className='modal-body mt-5'>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="table-responsive">
                                        <table className="table table-bordered" dir="rtl">
                                            <thead>
                                            <tr className="text-center">
                                                <th rowspan="3">م</th>
                                                <th rowspan="3">اسم الجهاز</th>
                                                <th rowspan="3">فئته</th>
                                                <th rowspan="3">رقم أمر العمل وتاريخه</th>
                                                <th colspan="3">يطبق عليـــه الغرامـــــة</th>
                                                <th colspan="2">لا يطبق عليــــه الغرامــــة</th>
                                            </tr>
                                            <tr className="text-center">
                                                <th colspan="3">عدد الأيام</th>
                                                <th colspan="3">القيمة اليومية</th>
                                                <th colspan="3">الإجمالي</th>
                                            </tr>
                                            <tr className="text-center">
                                                <th colspan="2">طبقت سابقا</th>
                                                <th colspan="2">يوجد مبررات</th>
                                            </tr>

                                            </thead>
                                            <tbody>
                                                <tr className="text-center">
                                                    <td>1</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>2</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>3</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>4</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>5</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>6</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>7</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='modal-body mt-5'>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="table-responsive" dir='rtl'>
                                        <table className="table table-bordered">
                                            <thead>
                                            <tr className="text-center">
                                                <th scope="col" className="pl-4 text-center fw-bolder">
                                                    <h5>
                                                        #
                                                    </h5>
                                                </th>
                                                <th scope="col">
                                                    <h5 className='text-center'>
                                                    مدير الصيانة بالموقع
                                                    </h5>
                                                </th>
                                                <th scope="col">
                                                    <h5 className='text-center'>
                                                    المشرف على أعمال المقاول(مهندس الوزارة) بالموقع 
                                                    </h5>
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="text-center">
                                                    <th scope="row" className="pl-4 text-center fw-bolder">الاسم:</th>
                                                    <td className='text-center'>test</td>
                                                    <td className='text-center'>test</td>
                                                </tr>
                                                <tr className="text-center">
                                                    <th scope="row" className="pl-4 text-center fw-bolder">التوقيع:</th>
                                                    <td className='text-center'>test</td>
                                                    <td className='text-center'>test</td>
                                                </tr>
                                                <tr className="text-center">
                                                    <th scope="row" className="pl-4 text-center fw-bolder">التاريخ:</th>
                                                    <td className='text-center'>test</td>
                                                    <td className='text-center'>test</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='modal-footer mt-5'>
                            <div className='container'>
                                <div className='row'>
                                    <div className='col-md-6 h-225px'>
                                        <h5 className='text-center'>ختم الموقع</h5>
                                    </div>
                                    <div className='col-md-6 h-225px'>
                                        <h5 className='text-center'>(ادارة الموقع / المواقع) ختم</h5>
                                    </div>
                                    <div className='col-md-12 text-right'>
                                        <h5>ملاحظات هامة جدا</h5>
                                        <ul dir='rtl'>
                                        <li>1.	أي أمر عمل مفتوح سواء في فترة المستخلص أو من فترة سابقة يجب إدراجه بالجدول .</li>
                                        <li>2.	أمر العمل المفتوح الذي طبق عليه حسميه في فترة سابقة يتم إيضاحه في المكان المخصص في الجدول.</li>
                                        <li>3.	أمر العمل الذي يوجد له مبرر من عدم تطبيق الحسميات عليه يتم إيضاح المبرر في المكان المخصص.</li>
                                        </ul>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
               </div>
           </div>
           <div className="modal fade" id="PreventiveMaintenanceModal" tabIndex="-1" role="dialog" aria-labelledby="PreventiveMaintenanceModallabel" aria-hidden="true" >
               <div className="modal-dialog modal-xl" role="document">
                   <div className="modal-content container" ref={componentpxRef}>
                       <div className="modal-header no-border">
                           <h5 className="modal-title container" id="exampleModalLabel">
                               <div className="row">
                                   <div className="col-md-4">
                                       <h5>Kingdom of Saudi Arabia</h5>
                                       <h5>Ministry of Health</h5>
                                       <h5>General Administration of Medical Maintenance</h5>
                                   </div>
                                   <div className="col-md-4 text-center">
                                       <img alt="Logo" src={logo} className="h-100px m-2"/>
                                       <h4>
                                       تفاصيل تطبيق جدول حسميات التقصير في أعمال الصيانة الوقائية للأجهزة الطبية                                       </h4>
                                   </div>
                                   <div className="col-md-4">
                                       <h5 className="text-right">المملكة العربية السعودية</h5>
                                       <h5 className="text-right">وزارة الصحة</h5>
                                       <h5 className="text-right">الإدارة العامة للصيانة الطبية</h5>
                                   </div>
                                    <div className='col-md-12'>
                                        <h5 className='text-center'>كراسة الشروط والمواصفات لصيانة وإصلاح الأجهزة والمعدات الطبية لمستشفيات منطقة تبوك </h5>
                                    </div>
                               </div>
                           </h5>
                       </div>
                       <div className="modal-header no-border">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                            <div className="col-md-4 text-left mt-3">
                                            <h4 className="n-border text-center">
                                            تبوك
                                            </h4>
                                        </div>
                                        <div className="col-md-8 text-right mt-3">
                                            <h5> :أعمال إصلاح وصيانة الأجهزة والمعدات الطبية الموجودة فى المواقع التابعة لصحة منطقة</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                        <div className="row">
                                                <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                            </div>
                                            <div className="col-md-6">
                                                <h5>
                                                :إسم المنطقة
                                                </h5>
                                            </div>
                                        </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="row">
                                        <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <h5>
                                            :بمقتضى العقد رقم
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                        <div className="row">
                                            <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                            </div>
                                            <div className="col-md-6">
                                                <h5>
                                                :إسم الموقع
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                <div className="col-md-6 mt-3">
                                    <div className="row">
                                        <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <h5>
                                            :تاريخ
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                       </div>
                       <div className='moda-body mt-3'>
                            <div className='modal-title'>
                                <div className='col-md-12'>
                                    <h5 className='text-center'>نموذج  رقم (  4  )</h5>
                                    <h5 className='text-center'>للدفعة الشهرية رقم (       )</h5>
                                    <h5 className='text-center'>المبرم مع : المملكة العربية السعودية</h5>
                                    <h5 className='text-center'>في المـدة من: 30/1/2024 الي 30/1/2024</h5>
                                    <h5 className='text-center'> ومدتها شهر ميلادي واحد</h5>
                                </div>
                            </div>
                       </div>
                       <div className='modal-body mt-5'>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="table-responsive">
                                        <table  className="table table-bordered" dir="rtl">
                                            <thead>
                                                <tr className="text-center">
                                                    <th>م</th>
                                                    <th>اسم الجهــاز</th>
                                                    <th>فئته</th>
                                                    <th>عدد أيام التأخير</th>
                                                    <th>القيمة اليومية للحسم كغرامة</th>
                                                    <th>القيمة الإجمالية للجهاز الواحد</th>
                                                    <th>عدد الأجهزة</th>
                                                    <th>القيمة الإجمالية للأجهزة</th>
                                                    <th>ملاحظات</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="text-center">
                                                    <td>1</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>2</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>3</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>4</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>5</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>6</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>7</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>8</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr clas>
                                                    <td>9</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td colspan="9">المجمـــــــــــــــــــــــــــــــــوع</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='modal-body mt-5'>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="table-responsive" dir='rtl'>
                                        <table className="table table-bordered">
                                            <thead>
                                            <tr className="text-center">
                                                <th scope="col" className="pl-4 text-center fw-bolder">
                                                    <h5>
                                                        #
                                                    </h5>
                                                </th>
                                                <th scope="col">
                                                    <h5 className='text-center'>
                                                    مدير الصيانة بالموقع
                                                    </h5>
                                                </th>
                                                <th scope="col">
                                                    <h5 className='text-center'>
                                                    المشرف على أعمال المقاول(مهندس الوزارة) بالموقع 
                                                    </h5>
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="text-center">
                                                    <th scope="row" className="pl-4 text-center fw-bolder">الاسم:</th>
                                                    <td className='text-center'>test</td>
                                                    <td className='text-center'>test</td>
                                                </tr>
                                                <tr className="text-center">
                                                    <th scope="row" className="pl-4 text-center fw-bolder">التوقيع:</th>
                                                    <td className='text-center'>test</td>
                                                    <td className='text-center'>test</td>
                                                </tr>
                                                <tr className="text-center">
                                                    <th scope="row" className="pl-4 text-center fw-bolder">التاريخ:</th>
                                                    <td className='text-center'>test</td>
                                                    <td className='text-center'>test</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='modal-footer mt-5'>
                            <div className='container'>
                                <div className='row'>
                                    <div className='col-md-6 h-225px'>
                                        <h5 className='text-center'>ختم الموقع</h5>
                                    </div>
                                    <div className='col-md-6 h-225px'>
                                        <h5 className='text-center'>(ادارة الموقع / المواقع) ختم</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
               </div>
           </div>
           <div className="modal fade" id="SubContractorModal" tabIndex="-1" role="dialog" aria-labelledby="SubContractorModallabel" aria-hidden="true" >
               <div className="modal-dialog modal-xl" role="document">
                   <div className="modal-content container" ref={componentplRef}>
                       <div className="modal-header no-border">
                           <h5 className="modal-title container" id="exampleModalLabel">
                               <div className="row">
                                   <div className="col-md-4">
                                       <h5>Kingdom of Saudi Arabia</h5>
                                       <h5>Ministry of Health</h5>
                                       <h5>General Administration of Medical Maintenance</h5>
                                   </div>
                                   <div className="col-md-4 text-center">
                                       <img alt="Logo" src={logo} className="h-100px m-2"/>
                                       <h4>
                                       جدول تكاليف مقاولي الباطن للأجهزة الطبية التخصصية الموجودة بالموقع للدفعة رقم (         ) للعقود التي تصرف بنظام الزيارات
                                       </h4>
                                   </div>
                                   <div className="col-md-4">
                                       <h5 className="text-right">المملكة العربية السعودية</h5>
                                       <h5 className="text-right">وزارة الصحة</h5>
                                       <h5 className="text-right">الإدارة العامة للصيانة الطبية</h5>
                                   </div>
                                    <div className='col-md-12'>
                                        <h5 className='text-center'>كراسة الشروط والمواصفات لصيانة وإصلاح الأجهزة والمعدات الطبية لمستشفيات منطقة تبوك </h5>
                                    </div>
                               </div>
                           </h5>
                       </div>
                       <div className="modal-header no-border">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                            <div className="col-md-4 text-left mt-3">
                                            <h4 className="n-border text-center">
                                            تبوك
                                            </h4>
                                        </div>
                                        <div className="col-md-8 text-right mt-3">
                                            <h5> :أعمال إصلاح وصيانة الأجهزة والمعدات الطبية الموجودة فى المواقع التابعة لصحة منطقة</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                        <div className="row">
                                                <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                            </div>
                                            <div className="col-md-6">
                                                <h5>
                                                :إسم المنطقة
                                                </h5>
                                            </div>
                                        </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="row">
                                        <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <h5>
                                            :بمقتضى العقد رقم
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                        <div className="row">
                                            <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                            </div>
                                            <div className="col-md-6">
                                                <h5>
                                                :إسم الموقع
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                <div className="col-md-6 mt-3">
                                    <div className="row">
                                        <div className="col-md-6 text-left">
                                                <h4 className="n-border text-center">
                                                    test
                                                </h4>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <h5>
                                            :تاريخ
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                       </div>
                       <div className='moda-body mt-3'>
                            <div className='modal-title'>
                                <div className='col-md-12'>
                                    <h5 className='text-center'>نموذج  رقم (  5  )</h5>
                                    <h5 className='text-center'>للدفعة الشهرية رقم (       )</h5>
                                    <h5 className='text-center'>المبرم مع : المملكة العربية السعودية</h5>
                                    <h5 className='text-center'>في المـدة من: 30/1/2024 الي 30/1/2024</h5>
                                    <h5 className='text-center'> ومدتها شهر ميلادي واحد</h5>
                                </div>
                            </div>
                       </div>
                       <div className='modal-body mt-5'>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="table-responsive">
                                        <table  className="table table-bordered" dir="rtl">
                                            <thead>
                                                <tr className="text-center">
                                                    <th>م</th>
                                                    <th>اسم الجهاز</th>
                                                    <th>عدد الأجهزة بالموقع</th>
                                                    <th>عدد الأجهزة المشمولة بالزيارة</th>
                                                    <th>قيمة الزيارة للجهاز الواحد حسب العقد</th>
                                                    <th>القيمة المستحقة لما تم صيانته</th>
                                                    <th>اسم مقاول الباطن</th>
                                                    <th>ملاحظات سبب عدم صيانة/ صرف قيمة باقي الأجهزة</th>
                                                </tr>
                                                <tr className="text-center">
                                                    <th colspan="8"> فئة (أ) </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="text-center">
                                                    <td>1</td>
                                                    <td>التصوير الطبقي</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>1</td>
                                                    <td>الرنين المغناطيسي</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>1</td>
                                                    <td>تصوير الشرايين</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>1</td>
                                                    <td>أشعة فلوروسكوبي</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>1</td>
                                                    <td>الأشعة الرقمية</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>1</td>
                                                    <td>تحليل كيمياء الدم</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>1</td>
                                                    <td>تحليل عد خلايا الدم</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>1</td>
                                                    <td>تحليل تخثر الدم</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>1</td>
                                                    <td>أجهزة ليزر العيون</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>1</td>
                                                    <td>تفتيت الحصى</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>1</td>
                                                    <td>أجهزة الطب النووي</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>1</td>
                                                    <td>قسطرة القلب</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>1</td>
                                                    <td>قياس كثافة العظام</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>1</td>
                                                    <td>وحدات التخدير</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>1</td>
                                                    <td>أجهزة التنفس الصناعي</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='modal-body mt-5'>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="table-responsive" dir='rtl'>
                                        <table className="table table-bordered">
                                            <thead>
                                            <tr className="text-center">
                                                <th scope="col" className="pl-4 text-center fw-bolder">
                                                    <h5>
                                                        #
                                                    </h5>
                                                </th>
                                                <th scope="col">
                                                    <h5 className='text-center'>
                                                    مدير الصيانة بالموقع
                                                    </h5>
                                                </th>
                                                <th scope="col">
                                                    <h5 className='text-center'>
                                                    المشرف على أعمال المقاول(مهندس الوزارة) بالموقع 
                                                    </h5>
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="text-center">
                                                    <th scope="row" className="pl-4 text-center fw-bolder">الاسم:</th>
                                                    <td className='text-center'>test</td>
                                                    <td className='text-center'>test</td>
                                                </tr>
                                                <tr className="text-center">
                                                    <th scope="row" className="pl-4 text-center fw-bolder">التوقيع:</th>
                                                    <td className='text-center'>test</td>
                                                    <td className='text-center'>test</td>
                                                </tr>
                                                <tr className="text-center">
                                                    <th scope="row" className="pl-4 text-center fw-bolder">التاريخ:</th>
                                                    <td className='text-center'>test</td>
                                                    <td className='text-center'>test</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='modal-footer mt-5'>
                            <div className='container'>
                                <div className='row'>
                                    <div className='col-md-6 h-225px'>
                                        <h5 className='text-center'>ختم الموقع</h5>
                                    </div>
                                    <div className='col-md-6 h-225px'>
                                        <h5 className='text-center'>(ادارة الموقع / المواقع) ختم</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
               </div>
           </div>
        </div>
    </div>
    )
}

export default Abstracts
